import { ThemeProvider } from "styled-components";
import { SessionProvider } from "next-auth/react";
import React from "react";

import '../styles/globals.css'
import { OfflineIndicator, Loader } from '../components/common'

import defaultTheme from 'utils/theme'
import { DataProvider } from 'utils/context'
import {useFirebaseSession} from "utils/hooks/useFirebaseSession";
import {AUTH_STATUSES} from "utils/constants";

const Hydration = ({ children }) => {
  const { status } = useFirebaseSession();
  const loading = status === AUTH_STATUSES.LOADING;
  return loading ? <Loader isVisible={true} height="100vh"/> : children
}

function MyApp({ Component, pageProps: { session, ...pageProps } }) {
  const getLayout = Component.getLayout || (page => page)
  return (
      <SessionProvider session={session}>
        <DataProvider>
          <ThemeProvider theme={defaultTheme}>
            <OfflineIndicator />
            <Hydration>
              {getLayout(<Component {...pageProps} />)}
            </Hydration>
          </ThemeProvider>
        </DataProvider>
      </SessionProvider>
  )
}

export default MyApp
